import { useLink } from 'react-router-stack';
import './index_mWeb.css';
import { CountdownTimer, RouteWrapper } from '../../component';
import { convertToDollars, isSmartPhone } from '../../utilities/helper';
import constants from '../../constants';
import redirectPage from '../../hoc/redirect';
import NavigationHeader from '../../component/navigation_header';
import ScreenBackgroundWrapper from '../../component/screen_background_wrapper';
import MiniGamesConfirmationModal from '../../component/minigame_confirmation_modal';
import Constants from '../../constants';
import React from 'react';
const PrizesMWeb = ({
  gameDetails,
  prizes,
  onPlayGameClick,
  onPressDismiss,
  confirmationModal,
  onConfirmationHandler,
  tableContainerStyle,
  tableRowStyle2,
  tableRowStyle1,
  tableHeaderStyle,
  teamName,
  leaderBoard,
  matchFlagStyle,
  poolPrizeEntryfeeHeaderStyle,
  rupeeCoinWrapperStyle,
  timerWrapperStyle,
  prizeTimeWrapperStyle,
  rupeeCoinBackDropStyle,
  playGameBtnStyle,
  currentScorePillStyle,
  highScorePillStyle,
  isGamePlayed
}: any) => {
  const { contest, gameImageLandscape, gameType, highScore = 0, currentScore = 0 } = gameDetails;
  const { winningsAmount, entryFee } = contest;
  const navigate = useLink();
  const onClickBack = () => {
    try {
      navigate.push('/');
    } catch (err) {
      navigate.go(-1);
    }
  };

  return (
    <RouteWrapper>
      <ScreenBackgroundWrapper>
        <div className="gameInfo_mainWrapper_mWeb" id={'gameInfo_mainWrapper_mWeb'}>
          <NavigationHeader onClickBack={onClickBack} title={'Game Info'} bgColor />
          <div className="gameInfo_wrapper_mWeb">
            <div className="gameInfo__container_mWeb">
              <div className="gameInfo_logoWrapper_mWeb">
                <div
                  className={` ${
                    isSmartPhone
                      ? 'landscapeGameLogo_mainWrapper_mWeb'
                      : 'landscapeGameLogo_mainWrapper'
                  }`}>
                  <div className="landscapeGameLogo_wrapper">
                    <img className="landscapeGameLogo_Bg" src={gameImageLandscape} />
                  </div>
                </div>
              </div>
              {gameType !== 'playerVsPlayer' && (
                <div className="gameInfo__liveWrapper_mWeb">
                  <img src={constants.Images.liveLandscape} />
                </div>
              )}

              <div>
                <div className="gameInfo__totalCashTextWrapper_mWeb">
                  <span className="gameInfo__totalCashText_mWeb">total cash prize</span>
                </div>
                <div className="gameInfo__AmountWrapper_mWeb">
                  <img className="gameInfo__rupeeImg_mWeb" src={constants.Images.coin}></img>
                  <span className="gameInfo__Amount_mWeb">
                    {convertToDollars(winningsAmount / 100)}
                  </span>
                </div>
              </div>
              {gameType === 'playerVsPlayer' ? (
                <div className="gameInfo__pvp__title__wrapper" style={matchFlagStyle}>
                  <Constants.Svgs.PlayerVsPlayerMobile />
                  <p>Player vs Player</p>
                </div>
              ) : (
                <div className="gameInfo__countdown__title__wrapper" style={matchFlagStyle}>
                  <Constants.Svgs.HourGlass />
                  <CountdownTimer isShowAlert={true} matchItem={gameDetails} />
                </div>
              )}
              <div
                className="gameInfo_prizepool_countdown_wrapper_mWeb"
                style={poolPrizeEntryfeeHeaderStyle}>
                <div className="gameInfo__poolTextWrapper_mWeb">
                  <span className="gameInfo__poolText_mWeb">total pool prize</span>
                </div>
                <div className="gameInfo__endsTextWrapper_mWeb">
                  <span className="gameInfo__endsText_mWeb">Entry Fee</span>
                </div>
              </div>

              <div className="gameInfo__prizeTimeWrapper_mWeb" style={prizeTimeWrapperStyle}>
                <div className="gameInfo__prizeWrapper_mWeb">
                  <div className="gameInfo__rupeeCoinWrapper_mWeb" style={rupeeCoinWrapperStyle}>
                    <div className="gameInfo__rupeeCoinContainer_mWeb">
                      <div className="gameInfo__rupeeWrapper_mWeb">
                        <img className="gameInfo__rupeeIcon_mWeb" src={constants.Images.coin}></img>
                        <span className="gameInfo__ruppeAmount_mWeb">
                          {' '}
                          {convertToDollars(winningsAmount / 100)}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="gameInfo__TimeWrapper_mWeb" style={timerWrapperStyle}>
                  <div className="gameInfo__sandTimeWrapper_mWeb">
                    <div className="gameInfo_sandIconWrapper_mWeb">
                      <img className="gameInfo_sandIcon_mWeb" src={constants.Images.coin}></img>
                      <span className="gameInfo__ruppeAmount_mWeb">
                        {convertToDollars(entryFee)}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              {isGamePlayed && gameType !== 'playerVsPlayer' && (
                <div className="gameInfo__currentScore__highScore__wrapper__mWeb">
                  <div
                    className="gameInfo__currentScore__container__mWeb"
                    style={currentScorePillStyle}>
                    <p className="gameInfo__currentScore__highScore__title__mWeb">
                      Your Last Score
                    </p>
                    <div className="gameInfoScore__seperator__mWeb"></div>
                    <p className="gameInfo__currentScore__highScore__score__mWeb">{currentScore}</p>
                  </div>
                  <div className="gameInfo__highScore__container__mWeb" style={highScorePillStyle}>
                    <p className="gameInfo__currentScore__highScore__title__mWeb">
                      Your Highest Score
                    </p>
                    <div className="gameInfoScore__seperator__mWeb"></div>
                    <p className="gameInfo__currentScore__highScore__score__mWeb">{highScore}</p>
                  </div>
                </div>
              )}
              {gameType !== 'playerVsPlayer' && (
                <div className="gameInfo__winPrizeWrapperWeb_mWeb">
                  <div className="gameInfo_youCanWinText_mWeb">you can win</div>
                  <div className="gameInfo__winPrizeWrapper_mWeb">
                    <div
                      className="gameInfo_winPrizeWrapper_backdrop"
                      style={rupeeCoinBackDropStyle}></div>
                    <div id="gameInfo__scroll" className="gameInfo__winPrizeInnerWrapper_mWeb">
                      {prizes.map((prize: any, id: number) => {
                        return (
                          <div key={id} className="gameInfo__prizeCard_mWeb">
                            <div
                              className={`gameInfo__rectangle_mWeb
                              ${prize['key'] <= 3 ? 'gameInfo__rectangleTopPrize_mWeb' : ''} 
                              `}>
                              <div className="gameInfo__prizeRupeeWrapper_mWeb"></div>
                              <span
                                className={`gameInfo_prizeMoney_mWeb
                              ${prize['key'] <= 3 ? 'gameInfo_TopprizeMoney_mWeb' : ''} 
                              `}>
                                {prize['type'] == 'rupees' ? prize['value'] / 100 : prize['value']}
                              </span>
                            </div>

                            <span className="gameInfo__Rank_mWeb">{'Rank '}</span>
                            <span className="gameInfo__Rank__value_mWeb">{prize['key']}</span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              )}
              {gameType !== 'playerVsPlayer' && (
                <React.Fragment>
                  <div className="leaderboard__title">Leaderboard</div>
                  <div
                    className={
                      isSmartPhone ? 'gameInfo_table_container_mWeb' : 'gameInfo_table_container'
                    }
                    style={tableContainerStyle}>
                    <div
                      className="table_header_container__mWeb row-center"
                      style={tableHeaderStyle}>
                      <div className="gameInfo_table_col1__mWeb row-center">Rank</div>
                      <div className="gameInfo_table_col2__mWeb "> Player</div>
                      <div className="gameInfo_table_col3__mWeb row-center">Score</div>
                      <div className="gameInfo_table_col4__mWeb row-center">Can Win</div>
                    </div>

                    {leaderBoard.map((item: any, idx: any) => (
                      <div
                        className={`gameInfo_table_row_container__mWeb ${
                          item.name == teamName && 'highlighted_table_row'
                        } ${idx === leaderBoard.length - 1 ? 'table_bottom_row' : ''}`}
                        key={idx}
                        style={idx % 2 == 0 ? tableRowStyle1 : tableRowStyle2}>
                        <div className="gameInfo_table_col1__mWeb row-center">{item.rank}.</div>
                        <div className="gameInfo_table_col2__mWeb">
                          {item.name ? item.name : 'you'}
                        </div>
                        <div className="gameInfo_table_col3__mWeb row-center">
                          {item.name == teamName ? highScore : item.score}
                        </div>
                        <div className="gameInfo_table_col4__mWeb row-center">
                          <img src={constants.Images.coin} />
                          <p>{`${convertToDollars(prizes[item.rank]?.value / 100)}`}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </React.Fragment>
              )}

              <button
                className="gameInfo__playBtn_mWeb"
                onClick={onPlayGameClick}
                style={playGameBtnStyle}>
                play game
              </button>
            </div>
          </div>
          <MiniGamesConfirmationModal
            visible={confirmationModal}
            onPressDismiss={onPressDismiss}
            onConfirmationHandler={onConfirmationHandler}
            EntryFee={entryFee}
          />
        </div>
      </ScreenBackgroundWrapper>
    </RouteWrapper>
  );
};

export default redirectPage(PrizesMWeb);
